import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { FileText, ExternalLink } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';
import { Button } from '../ui/button';

const ResearchPublicationsModal = ({ isOpen, onClose, publications }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-950 border-slate-800 text-white max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold">Research Publications</DialogTitle>
          <DialogDescription className="text-slate-400">
            Published research in energy systems and renewable technology
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-6">
            {publications.map((pub) => (
              <Card key={pub.id} className="bg-slate-900 border-slate-800 p-6 hover:border-blue-700 transition-all">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <FileText className="text-blue-500" size={32} />
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-white mb-2 leading-tight">
                      {pub.title}
                    </h3>
                    
                    <div className="flex items-center gap-3 mb-3">
                      <Badge variant="secondary" className="bg-blue-950 text-blue-400 border-blue-800">
                        {pub.year}
                      </Badge>
                      <span className="text-slate-400 text-sm">{pub.conference}</span>
                    </div>
                    
                    <p className="text-slate-300 mb-4 leading-relaxed">
                      {pub.description}
                    </p>
                    
                    <Button
                      variant="outline"
                      className="border-blue-700 text-blue-400 hover:bg-blue-950"
                      onClick={() => window.open(pub.link, '_blank')}
                    >
                      <ExternalLink size={16} className="mr-2" />
                      View Publication
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default ResearchPublicationsModal;
